// The Gatsby build needs this import.
// eslint-disable-next-line no-redeclare
import { CardMedia, CardMediaProps, styled } from '@mui/material';

export type MuiImageProps = CardMediaProps & {
  src: string; // Make `src` required
  alt?: string; // Add `alt` as optional
};

export const MuiImage = styled((props: MuiImageProps) => (
  <CardMedia component="img" {...props} />
))(({ theme, src }) => ({
  border: 0,
  objectFit: "unset",
}));